import { Component, Input } from "@angular/core";
import { CommonModule } from "@angular/common";
import { MatButtonModule } from "@angular/material/button";
import { MatIconModule } from "@angular/material/icon";
import { TranslateModule } from "@ngx-translate/core";

@Component({
  selector: "app-store-details-help-popover",
  standalone: true,
  imports: [CommonModule, TranslateModule, MatButtonModule, MatIconModule],
  templateUrl: "./store-details-help-popover.component.html",
  styleUrl: "./store-details-help-popover.component.scss",
})
export class StoreDetailsHelpPopoverComponent {
  @Input() closePopover?: () => void;
}
